export interface FilterDateInterface {
  startDate?: Date;
  endDate?: Date;
  isActive?: boolean;
}

export class FilterDate implements FilterDateInterface {
  public startDate?: Date;
  public endDate?: Date;
  public isActive?: boolean;

  constructor({
    startDate = undefined,
    endDate = undefined,
    isActive = undefined,
  }: FilterDateInterface) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.isActive = isActive;
  }
}
